import Vue from "vue";
import axios from "axios";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { APIRoute, EP } from "@/api-endpoints";
import { SurgicalPersonsState, SurgicalPerson } from "@/store/surgicalPersons/types";

export const actions: ActionTree<SurgicalPersonsState, RootState> = {
  loadAllSurgicalPeople({ commit, rootGetters }): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const url = APIRoute(EP.surgicalPeople.index);      
      axios.get(url).then((response: any) => {
        const data: SurgicalPerson[] = response.data.surgical_people;
        const filtered = data.filter((item: SurgicalPerson) => {
          // NOTE: this may be invalid using a getter inside an action
          const valid = rootGetters['features/regionIncludesProvinceCode'](item);
          if (valid) return item;
        });
        commit('setSurgicalPeople', filtered);
        resolve();
      }).catch((error: any) => {
        reject();
      });
    });
  }
};
